module.exports = __webpack_public_path__ + "images/ynwfc.a08c.png";